<template>
  <main class="full-mask" :style="{ display: !isDisplay ? 'none' : null }">
    
  </main>
</template>

<script>

export default {
  name: 'Mask',
  props: {
    isDisplay: {
      type: Boolean,
      default: false
    }
  }
}

</script>

<style lang="scss">

.full-mask {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 99;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
}

</style>